import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Info } from "lucide-react";

// Iter122dg · Banner informativo mostrato quando l'admin sta per attivare un account
// (condòmino o fornitore) con una email già registrata presso ALTRI Studi. Il banner
// NON blocca l'operazione: il multi-account cross-tenant è supportato — al login
// il soggetto sceglierà lo Studio dal selettore già presente.
export function EmailMultiTenantNotice({ email, enabled }) {
  const [info, setInfo] = useState(null); // { same_tenant, other_tenants, roles }
  useEffect(() => {
    if (!enabled) { setInfo(null); return; }
    const norm = (email || "").trim().toLowerCase();
    if (!norm || norm.length < 5) { setInfo(null); return; }
    const handle = setTimeout(() => {
      api.get(`/me/anagrafiche/email-check?email=${encodeURIComponent(norm)}`)
        .then((r) => setInfo(r.data))
        .catch(() => setInfo(null));
    }, 400);
    return () => clearTimeout(handle);
  }, [email, enabled]);
  if (!info || info.other_tenants === 0) return null;
  return (
    <div className="rounded-lg border-2 border-sky-300 bg-sky-50 p-3 flex items-start gap-2 text-sky-900" data-testid="email-cross-tenant-notice">
      <Info className="w-5 h-5 shrink-0 mt-0.5" />
      <div className="text-sm">
        <div className="font-semibold">Email già registrata in un altro Studio</div>
        <p className="mt-0.5">
          Questa email risulta associata a <b>{info.other_tenants}</b> {info.other_tenants === 1 ? "account" : "account"} presso {info.other_tenants === 1 ? "un altro Studio Ginius" : "altri Studi Ginius"}
          {info.roles?.length ? ` (ruolo: ${info.roles.join(", ")})` : ""}.
          Verrà creato un <b>nuovo account autonomo</b> per il Suo Studio; al login l&apos;utente sceglierà lo Studio dal selettore.
        </p>
      </div>
    </div>
  );
}
